import { useEffect } from "react";
import { identifyAmplitudeUser } from "../analytics";
import { useAuthenticatedUser } from "./AuthenticatedUserProvider";

export const AmplitudeProvider = () => {
	const { user } = useAuthenticatedUser();

	useEffect(() => {
		if (user.setupComplete) {
			identifyAmplitudeUser(user);
		}
	}, [user]);

	return null;
};
